import { Component,LOCALE_ID, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import {MatListModule} from '@angular/material/list';
import { AllLogsComponent } from './all-logs/all-logs.component';
import { TotalNutriComponent } from './total-nutri/total-nutri.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatLabel } from '@angular/material/form-field';
import { MatHint } from '@angular/material/form-field';
import { MatDateRangeInput } from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import { FoodService } from './food.service';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { FormsModule } from '@angular/forms';
import { 
  formatDate 
 } 
  from '@angular/common'; 
import moment from 'moment';
  import { NgIf, DatePipe } from '@angular/common';
  import { NgFor } from '@angular/common';
  import { NgClass } from '@angular/common';
  import { EditFoodComponent } from './edit-food/edit-food.component';
  
@Component({
  selector: 'app-all-food-logs',
  standalone: true,
  imports: [FormsModule,NgClass,NgFor,NgIf,MatNativeDateModule,MatInputModule,MatListModule,AllLogsComponent,TotalNutriComponent,MatDatepickerModule,MatFormFieldModule,HighchartsChartModule,DatePipe],
  templateUrl: './all-food-logs.component.html',
  styleUrl: './all-food-logs.component.css'
})
export class AllFoodLogsComponent implements OnChanges {
  @Input() memberId: any;
  @Input() memberName: any;
  @Input() startDate: any;
  @Input() endDate: any;
  @Input() selectedFoodLogId: any;
  @Input() selectedNutritionType: any;
  @Output() refresh = new EventEmitter<void>();
  
  allData:any=[];
  foodDetails:any=[];
  selectedType:any='All';
  isEdit:any=1;
  isList:any;
  Highcharts: typeof Highcharts = Highcharts;
  mealsChartOptions: Highcharts.Options = {};
  mealsChartUpdateFlag: boolean = false;
  mealsChartOneToOne: boolean = true;
  mealsChartRunOutsideAngular: boolean = false;
  showMealsChart: boolean = true;
  /** When true, meal per day graph and food log content are visible; toggle via dropdown arrow */
  mealPerDayFoodLogExpanded: boolean = false;
  mealsPerDayTotal: (number | null)[] = [];
  mealsPerDayGoal: (number | null)[] = [];
  mealsDates: string[] = [];
  mealsRawDates: string[] = [];
  constructor(private FoodService:FoodService) {
  }

  toggleMealPerDayFoodLog(): void {
    this.mealPerDayFoodLogExpanded = !this.mealPerDayFoodLogExpanded;
  }
  // Add these properties to the class
  private readonly DATE_STORAGE_KEY = 'foodLogDateRange';
  private readonly TYPE_STORAGE_KEY = 'selectedType';
  
  ngOnInit(): void {
    console.log('AllFoodLogsComponent initialized');
    console.log('MemberId:', this.memberId);
    console.log('StartDate:', this.startDate);
    console.log('EndDate:', this.endDate);
    if (!this.selectedNutritionType) {
      const storedType = localStorage.getItem(this.TYPE_STORAGE_KEY);
      if (storedType) {
        try {
          this.selectedType = JSON.parse(storedType) || this.selectedType;
        } catch {
          this.selectedType = this.selectedType;
        }
      }
    } else {
      this.selectedType = this.selectedNutritionType;
    }
    if (this.memberId && this.startDate && this.endDate) {
      this.getFoodLog(this.startDate, this.endDate);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedNutritionType'] && !changes['selectedNutritionType'].firstChange) {
      const typeValue = changes['selectedNutritionType'].currentValue;
      if (typeValue) {
        this.selectedType = typeValue;
        if (this.allData && this.allData.foodLogs) {
          this.foodFilter(this.selectedType);
          setTimeout(() => this.highlightSelectedLog(), 200);
        }
      }
    }
    if ((changes['startDate'] && !changes['startDate'].firstChange) || (changes['endDate'] && !changes['endDate'].firstChange)) {
      if (this.memberId && this.startDate && this.endDate) {
        this.getFoodLog(this.startDate, this.endDate);
      }
    }
    if (changes['selectedFoodLogId'] && !changes['selectedFoodLogId'].firstChange) {
      setTimeout(() => this.highlightSelectedLog(), 200);
    }
  }


  getFoodLog(fromDt:any,toDt:any){
    localStorage.setItem(this.DATE_STORAGE_KEY, JSON.stringify({ fromDt, toDt }));
    
    this.FoodService.getFoodLogs(this.memberId,fromDt,toDt).subscribe({
      next: (response) => {
        console.log('Food Log Response:', response);
        this.foodDetails = response;
        this.allData=  response;
        //this.allData = this.allData.foodLogs;
        if (this.foodDetails && this.foodDetails.foodLogs) {
          this.foodDetails = this.foodDetails.foodLogs;
          this.sortFoodDetailsByDateDesc();
        } else {
          console.warn('No foodLogs property found in response:', this.foodDetails);
          this.foodDetails = [];
        }
        // Process mealsPerDays for meals-per-day chart if available on the response
        if ((response as any).mealsPerDays && Array.isArray((response as any).mealsPerDays)) {
          this.processMealsPerDayData((response as any).mealsPerDays);
        } else {
          this.mealsPerDayTotal = [];
          this.mealsPerDayGoal = [];
          this.mealsDates = [];
          this.mealsRawDates = [];
        }
        console.log('Processed Food Details:', this.foodDetails);
        if (this.selectedType) {
          this.foodFilter(this.selectedType);
        } else {
          this.foodFilter('All');
        }
        setTimeout(() => this.highlightSelectedLog(), 200);
      },
      error: (error) => {
        console.error('Error fetching food logs:', error);
        this.foodDetails = [];
        this.allData = { foodLogs: [] };
      }
    });
  }

  handleFoodDeleted() {
    if (this.memberId && this.startDate && this.endDate) {
      this.getFoodLog(this.startDate, this.endDate);
    }
    this.refresh.emit();
  }
  // Add method to get saved dates
getSavedDateRange(): { fromDt: any, toDt: any } {
  const savedRange = localStorage.getItem(this.DATE_STORAGE_KEY);
  if (savedRange) {
      return JSON.parse(savedRange);
  }
  return { fromDt: null, toDt: null }; // Default values if none saved
}

  foodFilter(type:any){
      console.log('Filtering by type:', type);
      console.log('All data:', this.allData);
      //this.destorySession();
      this.selectedType=type;
      this.foodDetails=[];
      //console.log(this.allFoodDetails); 
      
      if(type == 'All'){
        if (this.allData && this.allData.foodLogs) {
          this.foodDetails = this.allData.foodLogs;
          this.sortFoodDetailsByDateDesc();
        } else {
          console.warn('No allData.foodLogs found');
          this.foodDetails = [];
        }
      }else{
      if (!this.allData || !this.allData.foodLogs) {
        console.warn('No allData.foodLogs found for filtering');
        this.foodDetails = [];
        return;
      }
      let foods = this.allData.foodLogs;
      console.log('Foods for filtering:', foods); 
      let allFood:any=[];
      
      for(let j=0;j<foods.length;j++){
        allFood.push({foodLogsInfo:[]});
          let calories=0;
          let protien=0;
          let carbs=0;
          let fat=0;
          let fiber=0;
          const foodData  = foods[j].foodLogsInfo.filter((x:any) => x.mealType == type);
          //this.foodDetails[j].foodLogsInfo = [];
         // console.log(foodData);
          for(let i =0;i<foodData.length;i++){
                calories = calories + foodData[i].total.calories;
                protien = protien + foodData[i].total.protein;
                carbs = carbs + foodData[i].total.carbs;
                fat = fat + foodData[i].total.fat;
                fiber = fiber + (foodData[i].total.fiber || 0);
                allFood[j].foodLogsInfo.push(foodData[i]);

               // allFood[j].logTime=
              } 
              allFood[j].date=foods[j].date;
              allFood[j].totalCalories = calories;
              allFood[j].totalProteins = protien;
              allFood[j].totalCarbs = carbs;
              allFood[j].totalFats = fat;
              allFood[j].totalFiber = fiber;    
      }
      //console.log(allFood);
      //this.foodDetails = [];
      this.foodDetails = allFood;
      this.sortFoodDetailsByDateDesc();
      //console.log( this.foodDetails);
    }
     // console.log(this.allData);
      // for(let j=0;j<foods.length;j++){
      //   let calories=0;
      //   let protien=0;
      //   let carbs=0;
      //   let fat=0;
      //   const foodData  = foods[j].foodLogsInfo.filter((x:any) => x.mealType == type);
      //   this.foodDetails[j].foodLogsInfo = [];
      //   console.log(this.allFoodDetails); 
      //   for(let i =0;i<foodData.length;i++){
      //     calories = calories + foodData[i].total.calories;
      //     protien = protien + foodData[i].total.protein;
      //     carbs = carbs + foodData[i].total.carbs;
      //     fat = fat + foodData[i].total.fat;
      //     this.foodDetails[j].foodLogsInfo.push(foodData[i]);
      //   }     
      //   this.foodDetails[j].totalCalories =    calories;
      //   this.foodDetails[j].totalProteins =    protien;
      //   this.foodDetails[j].totalCarbs =    carbs;
      //   this.foodDetails[j].totalFats =    fat;
      // }
     
     // console.log(this.foodDetails);
}

ngOnDestroy() {
  
  //  localStorage.setItem('foodData', JSON.stringify(this.foodDetails));
   // localStorage.setItem('wholeData', JSON.stringify(this.allData));
    localStorage.setItem('selectedType', JSON.stringify(this.selectedType));
    localStorage.setItem('startDate', JSON.stringify(this.startDate));
    localStorage.setItem('endDate', JSON.stringify(this.endDate));
  
}

/** Sort food log entries so most recent first: days by date descending; within each date, entries by time descending (most recent first). */
private sortFoodDetailsByDateDesc(): void {
  if (!this.foodDetails || !Array.isArray(this.foodDetails)) {
    return;
  }
  // Days: most recent date first
  this.foodDetails.sort((a: any, b: any) => {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();
    return dateB - dateA;
  });
  // Within each date: most recent time first (descending by logTime)
  this.foodDetails.forEach((dayGroup: any) => {
    if (dayGroup.foodLogsInfo && Array.isArray(dayGroup.foodLogsInfo)) {
      dayGroup.foodLogsInfo.sort((a: any, b: any) => {
        const timeA = this.getLogTimeMillis(a.logTime, dayGroup.date);
        const timeB = this.getLogTimeMillis(b.logTime, dayGroup.date);
        return timeB - timeA;
      });
    }
  });
}

/** Get timestamp for sorting; supports full ISO logTime or time-only combined with date. */
private getLogTimeMillis(logTime: string | null | undefined, fallbackDate: string | null | undefined): number {
  if (!logTime) return 0;
  const parsed = new Date(logTime).getTime();
  if (!isNaN(parsed)) return parsed;
  if (fallbackDate && logTime) {
    const combined = `${fallbackDate}T${logTime}`;
    const combinedParsed = new Date(combined).getTime();
    return isNaN(combinedParsed) ? 0 : combinedParsed;
  }
  return 0;
}

private highlightSelectedLog(): void {
  if (!this.selectedFoodLogId) {
    return;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  const target = document.getElementById(`food-log-${this.selectedFoodLogId}`);
  if (target) {
    target.classList.add('highlighted-food-log');
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => target.classList.remove('highlighted-food-log'), 3000);
  }
}

private processMealsPerDayData(mealsPerDays: any[]): void {
  if (!mealsPerDays || mealsPerDays.length === 0) {
    this.mealsPerDayTotal = [];
    this.mealsPerDayGoal = [];
    this.mealsDates = [];
    this.mealsRawDates = [];
    this.updateMealsChart();
    return;
  }

  mealsPerDays.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());

  this.mealsRawDates = mealsPerDays.map(m => moment(m.date).format('YYYY-MM-DD'));
  this.mealsDates = mealsPerDays.map(m => moment(m.date).format('ddd,<br/>MMM D'));
  this.mealsPerDayTotal = mealsPerDays.map(m => m.total ?? null);
  this.mealsPerDayGoal = mealsPerDays.map(m => m.goal ?? null);

  this.updateMealsChart();
}

private getMaxMealsValue(values: (number | null)[]): number | undefined {
  const validValues = values.filter(v => v !== null && v !== undefined && !isNaN(v as number)) as number[];
  if (validValues.length === 0) return undefined;
  return Math.ceil(Math.max(...validValues) * 1.1);
}

private updateMealsChart(): void {
  const selectedData: (number | null)[] = [
    ...this.mealsPerDayTotal,
    ...this.mealsPerDayGoal
  ];

  // hasData = at least one non-null value (0 is valid data); show "No data" only when both total and goal are null for all days
  const hasData = selectedData.some(v => v !== null && v !== undefined);

  let maxValue = this.getMaxMealsValue(selectedData);
  if (hasData && (maxValue === undefined || maxValue === 0)) {
    maxValue = 1; // ensure y-axis shows when all values are 0
  }

  const totalPoints = this.mealsDates.length;
  const isLongRange = totalPoints > 14;
  const xLabelStep = isLongRange ? Math.ceil(totalPoints / 14) : 1;

  const totalSeries: Highcharts.SeriesOptionsType = {
    type: 'line',
    name: 'Total Meals',
    data: this.mealsPerDayTotal.map((value, index) => ({
      x: index,
      y: value,
      custom: {
        dateStr: this.mealsRawDates[index] ? moment(this.mealsRawDates[index]).format('ddd, MMM D, YYYY') : ''
      }
    })) as Highcharts.PointOptionsObject[],
    color: '#FF3366'
  };

  const goalSeries: Highcharts.SeriesOptionsType = {
    type: 'line',
    name: 'Meals Per Day Goal',
    data: this.mealsPerDayGoal.map((value, index) => ({
      x: index,
      y: value,
      custom: {
        dateStr: this.mealsRawDates[index] ? moment(this.mealsRawDates[index]).format('ddd, MMM D, YYYY') : ''
      }
    })) as Highcharts.PointOptionsObject[],
    color: '#006BF2'
  };

  this.mealsChartOptions = {
    chart: {
      backgroundColor: '#F9F9F9',
      type: 'line',
      width: null,
      height: 400,
      reflow: true,
      panKey: 'shift',
      panning: {
        enabled: true,
        type: 'x'
      },
      zooming: {
        type: 'x'
      }
    },
    title: {
      text: 'Meals per Day',
      style: {
        fontSize: '14px'
      }
    },
    subtitle: {
      text: hasData ? '' : 'No data recorded for the selected date range',
      align: 'center',
      verticalAlign: 'middle',
      style: { color: '#888', fontSize: '14px', fontWeight: '500' }
    },
    xAxis: {
      type: 'datetime',
      categories: this.mealsDates,
      lineWidth: 2,
      labels: {
        useHTML: true,
        step: xLabelStep
      },
      minPadding: 0.05,
      maxPadding: 0.05
    },
    yAxis: {
      min: 0,
      max: maxValue,
      lineWidth: 2,
      gridLineWidth: hasData ? 1 : 0,
      minorGridLineWidth: 0,
      labels: { enabled: hasData },
      tickWidth: hasData ? undefined : 0,
      tickLength: hasData ? undefined : 0,
      title: {
        text: 'Meals'
      }
    },
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function () {
        if (this.y === null || this.y === undefined) {
          return false;
        }
        const customData = this.point.options.custom ?? {};
        const dateStr = customData['dateStr'] || '';
        return `<div>
          <span style="font-size: 12px; color: #fefefe;"><b>${this.series.name}</b></span><br>
          <span style="font-size: 12px; color: #fefefe;">Date: ${dateStr}</span><br>
          <span style="font-size: 12px; color: #fefefe;">Meals: ${this.y}</span>
        </div>`;
      },
      backgroundColor: 'rgba(0,0,0, 0.6)',
      borderWidth: 1,
      shadow: true,
      style: {
        color: '#fff',
        fontSize: '10pt',
        fontFamily: 'Urbanist, sans-serif'
      }
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      },
      series: {
        marker: {
          symbol: 'circle',
          enabled: true,
          radius: 3,
          lineWidth: 1,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },
    series: [totalSeries, goalSeries]
  };

  this.mealsChartUpdateFlag = !this.mealsChartUpdateFlag;
}
}
